import React from "react";
import * as styles from "./sidebar-nav-item.module.scss";
import { useToggleable } from "../../helper/hook-helper";
import { Link, useLocation } from "react-router";
import SidebarTooltip from "./sidebar-tooltip";
import { StyleableIcon } from "../../helper/icon-helper";
import { classArr } from "../../helper/style-helper";
import SidebarBetaLabel from "./sidebar-beta-label";

export interface SidebarNavItemProps {
	route: string;
	icon: StyleableIcon;
	label: string;
	expanded?: boolean;
	beta?: boolean;
}

export default function SidebarNavItem(props: SidebarNavItemProps) {
	const [isHover, enableHover, disableHover] = useToggleable();

	const loc = useLocation();
	const isSelected =
		loc.pathname === props.route ||
		loc.pathname.startsWith(`${props.route}/`);

	return (
		<div className={styles.navItem}>
			{isSelected && <div className={styles.selectionIndicator} />}
			<Link className={styles.link} to={props.route}>
				<button
					className={
						props.expanded
							? styles.selectable
							: styles.selectableSquare
					}
					onMouseEnter={enableHover}
					onMouseLeave={disableHover}
				>
					<div
						className={classArr(
							styles.icon,
							isSelected && styles.iconSelected,
						)}
					>
						{props.icon(24, "currentColor")}
					</div>

					{props.expanded && (
						<>
							<span
								className={classArr(
									styles.label,
									isSelected && styles.labelSelected,
								)}
							>
								{props.label}
							</span>

							{props.beta && (
								<SidebarBetaLabel
									className={styles.betaLabel}
								/>
							)}
						</>
					)}

					{isHover && !props.expanded && (
						<SidebarTooltip>{props.label}</SidebarTooltip>
					)}
				</button>
			</Link>
		</div>
	);
}
